import {
  formatLocaleDate,
  formatLocaleDateWithoutYear,
} from '@helpers/dateHelpers';

export const formatCompetitionPeriod = (
  startDate: Date,
  endDate: Date
): { start: string; end: string } => {
  const sameYear = startDate.getFullYear() === endDate.getFullYear();

  return {
    start: sameYear
      ? formatLocaleDateWithoutYear(startDate)
      : formatLocaleDate(startDate, false),
    end: formatLocaleDate(endDate, false),
  };
};
